import {Box, Button, Divider, Modal} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from '@mui/icons-material/Search';
import Grid from "@mui/material/Unstable_Grid2";
import React, {useEffect, useRef, useState} from "react";
import axiosInstance from "../../components/util/AxiosUtil";
import LayersIcon from "@mui/icons-material/Layers";
import IncidentTable from "./sts/IncidentTable";
import {useForm} from "react-hook-form";
import {viewModeType} from "../../components/const/CommCode";

const defaultValues = {sido: [], sigungu: [], nrnGentCd: ""};

const params = {sido: "", sigungu: "", nrnGentCd: ""};

const IncidentDiagramsBtn  = (
    {diagramChange,
        sidoList,
        setSidoList,
        sigunguList,
        setSigunguList,
        selectedSidoList,
        setSelectedSidoList,
        selectedSigunguList,
        setSelectedSigunguList,
        selectedNrnCdList,
        setSelectedNrnCdList
    }) => {

    //모달 오픈 상태
    const [open, setOpen] = useState(false);

    //시도, 구군, 에너지원 장애 건수
    const [sidoTotalCnt, setSidoTotalCnt] = useState(0);
    const [sigunguTotalCnt, setSigunguTotalCnt] = useState(0);
    const [nrnTotalCnt, setNrnTotalCnt] = useState(0);

    //구군 정보 펼침 유무
    const [sigunguExpanded, setSigunguExpanded] = useState(false);

    //에너지원 장애건수 목록
    const [nrnCntList, setNrnCntList] = useState([]);
    
    // 시도,구군 에너지원 검색필터
    const {
        handleSubmit : handleSubmit,
        getValues: getValues,
        setValue : setValue
    } = useForm( {defaultValues} );

    //시도 목록 조회
    const getSidoList = () => {
        axiosInstance.get('/sidoList').then((Response) => {
            if(Response.request.status === 200) {
                const list = Response.data.list;
                if(!list){
                    return;
                }
                list.map((row) => row.active =  false);

                //전체 장애 건수 저장
                const sidoCnt = list[0].totalCnt ? list[0].totalCnt : 0;
                setSidoTotalCnt(sidoCnt)

                //시도 목록 저장
                setSidoList(list);
            }
        })
    }

    //에너지원 테이블 데이터 목록 조회
    const getNrnIncList = (sido, sigungu) => {
        axiosInstance.get('/oosNrnIncList', {params: {sido: sido, sigungu:sigungu}}).then((Response)=>{
            if(Response.request.status === 200){
                setNrnTotalCnt(Response.data.totalCnt ? Response.data.totalCnt : '0');
                setNrnCntList(Response.data.list);
            }
        });
    }

    //시도 버튼 클릭 이벤트
    const sidoBtnClickEvt = (el, idx) => {
        if(!open) return;
        let list = [...sidoList];
        list.forEach(item => {
            if(item.sido !== el.sido) return;
            item.active = !el.active;
        })

        //선택된 시도 조회
        const newSido = list
            .filter(item => item.active && item.sido !== undefined)
            .map(item => item.sido);
        setValue("sido", newSido);
        setSidoList(list);

        if(newSido.length === 1){
            getSigunguList(newSido[0]);
        }else{
            setValue("sigungu", []);
            setSigunguExpanded(false);
        }

        getNrnFilterToString();
    }

    //시도,시군구 변경시 에너지원 조회 파라미터 변경
    const getNrnFilterToString = () => {

        //var obj = {sido: filterData.sido, sigungu: filterData.sigungu, nrnGentCd: filterData.nrnGentCd};
        var sidoArr = [...getValues().sido];
        var sigunguArr = [...getValues().sigungu];

        var sido = sidoArr.length ? `('${sidoArr.join("', '")}')` : "";
        var sigungu = sigunguArr.length ? `('${sigunguArr.join("', '")}')` : "";

        getNrnIncList(sido, sigungu);
    }


    // 구군 목록 조회
    const getSigunguList = (sido) => {
        if(!sido){
            return;
        }
        setSigunguExpanded(true);

        axiosInstance.get('/sigunguList', {params: {sido: sido}}).then((Response) => {
            if(Response.request.status === 200) {
                const list = Response.data.list;
                if(!list) return;

                //시군구 장애 건수 저장
                const sigunguCnt = list[0].totalCnt ? list[0].totalCnt : 0;
                setSigunguTotalCnt(sigunguCnt);

                //list.map(item => item.active = false);
                 list.map((item) => {
                     var newSigungu = selectedSigunguList.find(e => e === item.sigungu);
                     if(newSigungu){
                         item.active = true;
                     }
                 })
                 setSigunguList(list);
                 setValue("sigungu", selectedSigunguList);
                 getNrnFilterToString();
            }
        })
    }

    //구군 버튼 클릭 이벤트
    const sigunguBtnClickEvt = (el, idx) => {
        if(!open) return;
        let list = [...sigunguList];
        list.forEach(item => {
            if(item.sigungu  !== el.sigungu ) return;
            item.active = !el.active;
        })

        //선택된 시도 조회
        const newSigungu = list
            .filter(item => item.active && item.sigungu !== undefined)
            .map(item => item.sigungu);
        setValue("sigungu", newSigungu);

        getNrnFilterToString();
        setSigunguList(list);
    }

    //에너지원 셀 클릭 이벤트
    const nrnClickEvent = (e) => {
        if(!e){
            nrnAllCheck();
            return;
        }

        var arr = [...selectedNrnCdList];
        var find = arr.find(el => el === e.currentTarget.dataset.nrncd);
        if(!find){
            arr.push(e.currentTarget.dataset.nrncd);
        }else{
            arr = arr.filter(el => el !== e.currentTarget.dataset.nrncd);
        }
        setSelectedNrnCdList(arr);
    }

    //전체 버튼 클릭시
    const nrnAllCheck = () => {
        var arr = [];
        setSelectedNrnCdList(arr);
    }

    const diagramChangeFunc = (form) => {
        setSelectedSidoList(
            form.sido ? form.sido : []
        );
        setSelectedSigunguList(
            form.sigungu ? form.sigungu : []
        )

        let nrn = [...selectedNrnCdList];

        let obj = {
            sido: getValues().sido,
            sigungu: getValues().sigungu,
            nrnGentCd: nrn
        }

        diagramChange(obj);
        setOpen(false);
    }

    useEffect(() => {
        getSidoList();
    }, []);

    useEffect(() => {
        if(!open) return;
        //시도
        let newSido = [...selectedSidoList];
        setValue("sido", newSido);
        sidoList.map((item) => {
            var find = selectedSidoList.find(e => item.sido === e);
            if(find){
                item.active = true;
            }
        })

        if(newSido.length === 1){
            getSigunguList(newSido[0]);
        }else{
            setValue("sigungu", []);
            setSigunguExpanded(false);
            getNrnFilterToString();
        }
    }, [open])

    return(
        <>
            {/* 장애 버튼 */}
            <Button variant="contained"
                    size="large"
                    color="primary"
                    sx={{p: 2, height: '52px', width: 1}}
                    startIcon={<LayersIcon/>}
                    onClick={() => {
                        setOpen(true);
                    }}
            >시도별 장애 확인</Button>

            {/* 시도별 장애확인 모달 */}
            <Modal open={open}
                   onClose={e => setOpen(false)}
                   aria-labelledby="parent-modal-title"
                   aria-describedby="parent-modal-description"
                   sx={{borderColor: "gray"}}
                   className="inc_diagram_modal"
            >
                <Box className="Modal" sx={{bgcolor: "#f5fcff", p: 2}}
                     style={{border: "1px solid gray", borderRadius: "10px"}}>
                    <h3 id="parent-modal-title" className="limiter">시도별 장애확인</h3>

                    <Grid sx={{p: 2, mt: 1, bgcolor: "#fff", borderRadius: "15px", border: "1px solid #e0e0e0"}}>
                        <div style={{
                            fontSize: "15px",
                            fontWeight: "bold",
                            boxShadow: "inset 0 -8px 0 #bbdefb",
                            width: "fit-content",
                            marginBottom: "15px"
                        }}>
                            <span style={{marginRight: "20px", color: "red"}}>시도</span>
                            <span style={{marginRight: "10px"}}>전체 장애</span>
                            <span>{sidoTotalCnt}</span>
                            <span>건</span>
                        </div>

                        <div style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-evenly"
                        }}>
                            {sidoList.length > 0 ?
                                sidoList.map((el, idx) => (
                                    <button key={idx}
                                            className={`incident_sido_chip_style ${el.active ? "active" : ""}`}
                                            onClick={() => sidoBtnClickEvt(el, idx)}>
                                    <span className="incident_sido_long_text"
                                          style={{fontSize: "14px", fontWeight: "bold"}}
                                    >{el.sido}</span>
                                        <span><b>{el.incCnt}</b>건</span>
                                    </button>
                                ))
                                : null
                            }
                        </div>
                    </Grid>

                    {/*시군구 chip*/}
                    <div style={{marginTop: "10px"}}>
                        <div className={`sigungu_accordion ${sigunguExpanded ? 'open' : ''}`}>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "bold",
                                boxShadow: "inset 0 -8px 0 #bbdefb",
                                width: "fit-content",
                                marginBottom: "15px"
                            }}>
                                <span style={{marginRight: "20px", color: "red"}}>구군</span>
                                <span style={{marginRight: "10px"}}>전체 장애</span>
                                <span>{sigunguTotalCnt}</span>
                                <span>건</span>
                            </div>
                            <div style={{
                                overflowY: "auto",
                                maxHeight: "135px",
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "space-evenly",
                                overflowX: "hidden"
                            }}>
                                {sigunguList.length > 0 ?
                                    sigunguList.map((el, idx) => (
                                        <button key={idx}
                                                className={`incident_sigungu_chip_style ${el.active ? "active" : ""}`}
                                                onClick={() => sigunguBtnClickEvt(el, idx)}>
                                            <span style={{fontSize: "14px", fontWeight: "bold"}}>{el.sigungu}</span>
                                            <span><b>{el.incCnt}</b>건</span>
                                        </button>
                                    ))
                                :null}
                            </div>
                        </div>
                    </div>

                    {/*에너지 종류별 건수 테이블*/}
                    <div style={{marginTop: "10px"}}>
                        <Grid sx={{pt: 2,pl:2, pr:2, bgcolor: "#fff", borderRadius: "15px", border: "1px solid #e0e0e0"}}>
                            <div style={{
                                fontSize: "15px",
                                fontWeight: "bold",
                                boxShadow: "inset 0 -8px 0 #bbdefb",
                                width: "fit-content",
                                marginBottom: "15px"
                            }}>
                                <span style={{marginRight: "20px", color: "red"}}>에너지원</span>
                                <span style={{marginRight: "10px"}}>전체 장애</span>
                                <span>{nrnTotalCnt}</span>
                                <span>건</span>
                            </div>

                            <Grid xs={12} sm={12} md={12} lg={12} xl={12} style={{"marginLeft":"-16px", "marginRight":"-16px"}}>
                                <table style={{ "fontSize":"11px", "width": "100%"}} className="inc_diagram_table">
                                    <thead className="p-2" style={{"background": "rgba(228, 232, 240)"}}>
                                    {[{}].map((item, index) => {
                                        var list = [...selectedNrnCdList];
                                        return (
                                            <tr key={index}>
                                                <th className="incident_table_top_left2" style={{"width": "10%"}}></th>
                                                <th data-nrncd="0" className="incident_table_top_left2"
                                                    style={{"width": "10%"}}>전체
                                                </th>
                                                <th data-nrncd="100" className={`incident_table_top_left2 ${list.find(e => e === '100') ? "nrnActive" : ""}`}
                                                    style={{"width": "10%"}}>태양광
                                                </th>
                                                <th data-nrncd="200" className={`incident_table_top_left2 ${list.find(e => e === '200') ? "nrnActive" : ""}`}
                                                    style={{"width": "10%"}}>지열
                                                </th>
                                                <th data-nrncd="300" className={`incident_table_top_left2 ${list.find(e => e === '300') ? "nrnActive" : ""}`}
                                                    style={{"width": "10%"}}>태양열
                                                </th>
                                                <th data-nrncd="310" className={`incident_table_top_left2 ${list.find(e => e === '310') ? "nrnActive" : ""}`}
                                                    style={{"width": "10%"}}>태양열(자연)
                                                </th>
                                                <th data-nrncd="400" className={`incident_table_top_left2 ${list.find(e => e === '400') ? "nrnActive" : ""}`}
                                                    style={{"width": "10%"}}>연료전지
                                                </th>
                                                <th data-nrncd="700" className={`incident_table_top_left2 ${list.find(e => e === '700') ? "nrnActive" : ""}`}
                                                    style={{"width": "10%"}}>ESS
                                                </th>
                                                <th data-nrncd="600" className={`incident_table_top_left2 ${list.find(e => e === '600') ? "nrnActive" : ""}`}
                                                    style={{"width": "10%"}}>풍력
                                                </th>
                                                <th data-nrncd="500" className={`incident_table_top_left2 ${list.find(e => e === '500') ? "nrnActive" : ""}`}
                                                    style={{"width": "10%"}}>기타
                                                </th>
                                            </tr>
                                        )
                                    })}
                                    </thead>
                                    <tbody>
                                    {nrnCntList.map((item, idx) => {
                                        var list = [...selectedNrnCdList];
                                        return (
                                            <tr key={item.oosStsCd} className="text-center">
                                                <td className="incident_table_top_left2">{item.oosStsNm}</td>
                                                <td data-nrncd="0" onClick={e => nrnClickEvent(null)}
                                                    className="incident_table_top_left2">{item.totalCnt}</td>
                                                <td data-nrncd="100" onClick={e => nrnClickEvent(e)}
                                                    className={`incident_table_top_left2 ${list.find(e => e === '100') ? "nrnActive" : ""}`}>{item.nrn100}</td>
                                                <td data-nrncd="200" onClick={e => nrnClickEvent(e)}
                                                    className={`incident_table_top_left2 ${list.find(e => e === '200') ? "nrnActive" : ""}`}>{item.nrn200}</td>
                                                <td data-nrncd="300" onClick={e => nrnClickEvent(e)}
                                                    className={`incident_table_top_left2 ${list.find(e=> e==='300') ? "nrnActive" : ""}`}>{item.nrn300}</td>
                                                <td data-nrncd="310" onClick={e => nrnClickEvent(e)}
                                                    className={`incident_table_top_left2 ${list.find(e=> e==='310') ? "nrnActive" : ""}`}>{item.nrn310}</td>
                                                <td data-nrncd="400" onClick={e => nrnClickEvent(e)}
                                                    className={`incident_table_top_left2 ${list.find(e=> e==='400') ? "nrnActive" : ""}`}>{item.nrn400}</td>
                                                <td data-nrncd="700" onClick={e => nrnClickEvent(e)}
                                                    className={`incident_table_top_left2 ${list.find(e=> e==='700') ? "nrnActive" : ""}`}>{item.nrn700}</td>
                                                <td data-nrncd="600" onClick={e => nrnClickEvent(e)}
                                                    className={`incident_table_top_left2 ${list.find(e=> e==='600') ? "nrnActive" : ""}`}>{item.nrn600}</td>
                                                <td data-nrncd="500" onClick={e => nrnClickEvent(e)}
                                                    className={`incident_table_top_left2 ${list.find(e=> e==='500') ? "nrnActive" : ""}`}>{item.nrn500}</td>
                                            </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </Grid>
                        </Grid>
                    </div>

                    {/*버튼목록*/}
                    <Grid sx={{display: 'flex', width: '100%', justifyContent: 'flex-end', mt: 2}}>
                        <Button variant="contained"
                                size="large"
                                color="primary"
                                startIcon={<SearchIcon/>}
                                onClick={handleSubmit(diagramChangeFunc)}
                        >조회</Button>
                        <Button variant="contained"
                                size="large"
                                color="primary"
                                startIcon={<CloseIcon/>}
                                sx={{ml: 2}}
                                onClick={e => setOpen(false)}
                        >닫기</Button>
                    </Grid>
                </Box>

            </Modal>
        </>
    )
}

export default IncidentDiagramsBtn;